import React from 'react'
import { makeStyles, CircularProgress, CircularProgressProps } from '@material-ui/core'
import { Color } from 'theme/style'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  bottom: {
    color: theme.palette.grey[200],
    position: 'absolute',
    left: 0,
  },
  top: {
    color: Color.Primary,
    animationDuration: '600ms',
    position: 'absolute',
    left: 0,
  },
  circle: {
    strokeLinecap: 'round',
  },
}))

interface SpinnerProps extends CircularProgressProps {
  type?: 'default' | 'small'
}

const Spinner = ({ ...props }: SpinnerProps) => {
  const classes = useStyles()

  const typeValue = props.type ?? 'default'

  let sizeValue = 40
  if (typeValue === 'small') sizeValue = 20
  if (typeValue === 'default') sizeValue = 40

  let thickness = 4
  if (typeValue === 'small') thickness = 5
  if (typeValue === 'default') thickness = 3

  return (
    <div className={classes.root} style={{ width: sizeValue, height: sizeValue, flex: '0 0 ' + sizeValue + 'px' }}>
      <CircularProgress variant="determinate" className={classes.bottom} size={sizeValue} thickness={thickness} value={100} {...props} />
      <CircularProgress variant="indeterminate" disableShrink className={classes.top} size={sizeValue} thickness={thickness} classes={{
        circle: classes.circle,
      }} {...props}
      />
    </div>
  )
}

export default Spinner
